/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum ProviderName {
    AWS = 'AWS',
    Anomaly_Detector = 'Anomaly_Detector',
    AppDynamics = 'AppDynamics',
    App_Insights = 'App_Insights',
    Azure = 'Azure',
    AzureStack = 'AzureStack',
    Azure_CSP = 'Azure_CSP',
    Azure_CSP_Direct = 'Azure_CSP-Direct',
    Azure_Devops = 'Azure_Devops',
    Azure_EA = 'Azure_EA',
    Azure_MCA = 'Azure_MCA',
    Azure_Security_Graph = 'Azure_Security_Graph',
    Azure_Sentinel = 'Azure_Sentinel',
    Cloudstack = 'Cloudstack',
    Corestack = 'Corestack',
    DockerHub = 'DockerHub',
    ElasticSearch = 'ElasticSearch',
    Freshservice = 'Freshservice',
    GCP = 'GCP',
    GitHub = 'GitHub',
    JIRA_DataCenter = 'JIRA_DataCenter',
    JIRA_ServiceDesk = 'JIRA_ServiceDesk',
    JIRA_ServiceManagement = 'JIRA_ServiceManagement',
    Jenkins = 'Jenkins',
    Logstash = 'Logstash',
    MS_VMM = 'MS_VMM',
    Microsoft_Teams = 'Microsoft_Teams',
    Nagios = 'Nagios',
    Newrelic = 'Newrelic',
    OCI = 'OCI',
    Openstack = 'Openstack',
    PrivateCloud = 'PrivateCloud',
    Prometheus = 'Prometheus',
    Qualys = 'Qualys',
    Rackspace = 'Rackspace',
    RedHat_Satellite = 'RedHat_Satellite',
    ServiceNow = 'ServiceNow',
    TCL_ITSM = 'TCL_ITSM',
    Tenable_Nessus = 'Tenable_Nessus',
    VMware = 'VMware',
    VMware_VCD = 'VMware_VCD',
    ZOHO_ServiceDesk = 'ZOHO_ServiceDesk',
    Zabbix = 'Zabbix',
    vCenter = 'vCenter'
}
